/** UX expiry check only; signature/issuer validation remains the server's job. */
export function accessTokenNeedsRenewal(token: string | undefined): boolean {
  try {
    const payload = token?.split('.')[1];
    if (!payload) return true;
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const {exp} = JSON.parse(atob(base64.padEnd(Math.ceil(base64.length / 4) * 4, '=')));
    return typeof exp !== 'number' || !Number.isFinite(exp) || exp * 1000 <= Date.now();
  } catch {
    return true;
  }
}
